import './index.scss'

export default function LayoutPartner({ children }) {
  return (
    <div id="LayoutPartner">
      <div className="LayoutPartner_children">{children}</div>
    </div>
  )
}
